module.exports = __webpack_public_path__ + "static/media/toe.2e7d10ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toe.png
// module id = 51
// module chunks = 0